import { render } from "./ViewUser.vue?vue&type=template&id=42f6f7e4&ts=true"
import script from "./ViewUser.vue?vue&type=script&lang=ts"
export * from "./ViewUser.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__